import app from 'flarum/forum/app';
import icon from 'flarum/common/helpers/icon';
import extractText from 'flarum/common/utils/extractText';

/**
 * Campo de contraseña con ojo mostrar/ocultar (PKG-FORO-PASSWORD-SETTINGS-UX).
 *
 * Es una FUNCIÓN de pintado y no un componente con estado: quién ve qué contraseña es una
 * decisión del formulario dueño (el modal de Configuración la resetea al abrir; el Form A la
 * conserva mientras se corrige un error), así que el booleano vive allí y aquí solo se pinta.
 *
 * El botón es `type="button"` para que Enter siga enviando el formulario y el clic del ojo no
 * cuente como submit. `aria-pressed` + el rótulo dicen el estado a un lector de pantalla; el
 * icono sigue el par del editor (`addEditorPreview`): ojo abierto para «mostrar», tachado para
 * «ocultar».
 *
 * OJO con el atributo `type`: lo pone ESTA función según `shown`. Si el llamador pasara el
 * suyo en `attrs`, ganaría el del llamador y el ojo dejaría de hacer nada — por eso se aplica
 * después del spread.
 */
export default function revealablePassword(attrs: Record<string, any>, shown: boolean, onToggle: () => void) {
  const label = extractText(app.translator.trans(`umbral-comunidad.forum.password_reveal.${shown ? 'hide' : 'show'}`));

  return (
    <div className="CmPwReveal">
      <input {...attrs} type={shown ? 'text' : 'password'} />
      <button
        type="button"
        className="CmPwReveal-eye"
        data-cm-pw-eye={shown ? 'on' : 'off'}
        title={label}
        aria-label={label}
        aria-pressed={shown ? 'true' : 'false'}
        onclick={onToggle}
      >
        {icon(shown ? 'fas fa-eye-slash' : 'far fa-eye')}
      </button>
    </div>
  );
}
